import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function PrivacyPage() {
  return (
    <>
      <Header />
      <main className="bg-[#FAFAFA] pt-32 pb-16">
        <div className="max-w-[780px] mx-auto px-5 sm:px-8 lg:px-10">
          <Link
            to="/"
            className="inline-block text-[13px] text-[#173B86] hover:underline mb-6"
          >
            ← Back to home
          </Link>
          <h1 className="font-serif text-[38px] sm:text-[44px] text-[#173B86] mb-2">
            Privacy Policy
          </h1>
          <p className="text-[13px] text-[#5b6a85] mb-10">
            Last updated: February 2026
          </p>

          <div className="space-y-8 text-[14.5px] leading-[1.7] text-[#1A2B4A]/90">
            <section>
              <h2 className="font-serif text-[22px] text-[#173B86] mb-3">
                1. Information we collect
              </h2>
              <p>
                When you request a quote we collect the information you submit
                in the form: your full name, phone number, email address, ZIP
                code, home size, and the type of cleaning service you are
                interested in. We do not collect payment information through
                this website.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-[22px] text-[#173B86] mb-3">
                2. How we use your information
              </h2>
              <p>
                We use the information you provide to contact you about your
                quote request, schedule cleaning services, and respond to
                questions. We will not sell, rent, or share your information
                with third parties for marketing purposes.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-[22px] text-[#173B86] mb-3">
                3. How we store your information
              </h2>
              <p>
                Quote requests are stored in a secure database and are only
                accessible by Tina's Cleaning Company. Quote records are kept
                only as long as needed to provide the service.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-[22px] text-[#173B86] mb-3">
                4. Cookies &amp; analytics
              </h2>
              <p>
                The website may use basic cookies or analytics to understand
                how visitors use the site. These do not collect personal
                information that can identify you individually.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-[22px] text-[#173B86] mb-3">
                5. Your rights
              </h2>
              <p>
                You may ask us at any time to update, correct, or delete your
                personal information by emailing{" "}
                <a
                  href="mailto:taniamac90210@gmail.com"
                  className="text-[#173B86] hover:underline"
                >
                  taniamac90210@gmail.com
                </a>
                .
              </p>
            </section>

            <section>
              <h2 className="font-serif text-[22px] text-[#173B86] mb-3">
                6. Contact
              </h2>
              <p>
                Questions about this policy? Email{" "}
                <a
                  href="mailto:taniamac90210@gmail.com"
                  className="text-[#173B86] hover:underline"
                >
                  taniamac90210@gmail.com
                </a>
                .
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
